(function () {
function hf3InitStack(root) {
  if (!root || root.__hf3) return; root.__hf3 = true;
  var products;
  try { products = JSON.parse(root.querySelector('[data-products]').textContent); } catch (e) { products = []; }
  var extra = {};
  var addon = null;
  try { addon = JSON.parse(root.querySelector('[data-addon]').textContent); } catch (e) {}
  if (addon && !addon.available) addon = null;
  try { extra = JSON.parse(root.querySelector('[data-extra]').textContent); } catch (e) {}
  var lowAt = parseInt(root.getAttribute('data-low'), 10) || 10;
  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 5000;
  var inStock = products.filter(function (p) { return p.available; });
  if (!inStock.length) { root.querySelector('.hf3sb__wrap').style.display = 'none'; return; }

  var startH = root.getAttribute('data-start');
  var order = inStock.slice();
  var si = -1; for (var k = 0; k < order.length; k++) if (order[k].handle === startH) si = k;
  if (si > 0) order.unshift(order.splice(si, 1)[0]);
  var state = { addon: false, n: 3, active: 0, slots: [0, 1, 2].map(function (i) { return order[i % order.length].handle; }) };
  var find = function (h) { for (var i = 0; i < products.length; i++) if (products[i].handle === h) return products[i]; return inStock[0]; };
  var money = function (c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); };
  var img = function (src, alt) { return src ? '<img src="' + src + '" alt="' + (alt || '').replace(/"/g, '&quot;') + '" loading="lazy">' : ''; };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };

  function stackTotal(n) {
    var prices = state.slots.slice(0, n).map(function (h) { return find(h).price; });
    var sum = prices.reduce(function (a, b) { return a + b; }, 0);
    var off = n >= 3 ? Math.round(Math.min.apply(null, prices) / 2) : 0;
    return { sum: sum, total: sum - off, off: off };
  }

  function render() {
    var n = state.n, a = Math.min(state.active, n - 1);
    var tiers = [
      { n: 3, name: 'Stack of 3', sub: '3rd pair 50% off', badge: 'BEST VALUE' },
      { n: 2, name: 'Stack of 2', sub: 'Mix any 2 styles', badge: '' },
      { n: 1, name: 'Single pair', sub: inStock.length + ' styles in stock', badge: '' }
    ];
    root.querySelector('[data-tiers]').innerHTML = tiers.map(function (t) {
      var tt = stackTotal(t.n);
      var sub = t.n === 3 ? t.sub + ' · Save ' + money(tt.off) + (tt.total >= threshold ? ' + ships free' : '') : t.sub;
      return '<button type="button" class="hf3sb__tier" data-tier="' + t.n + '" aria-pressed="' + (t.n === n) + '">' +
        '<span><span class="hf3-serif hf3sb__tier-name">' + t.name + '</span>' + (t.badge ? '<span class="hf3sb__badge">' + t.badge + '</span>' : '') +
        '<span class="hf3sb__tier-sub">' + sub + '</span></span>' +
        '<span><span class="hf3-serif hf3sb__price">' + money(tt.total) + '</span>' + (tt.off ? '<span class="hf3sb__compare">' + money(tt.sum) + '</span>' : '') + '</span></button>';
    }).join('');

    var slotHtml = '', thumbHtml = '';
    for (var i = 0; i < n; i++) {
      var p = find(state.slots[i]);
      slotHtml += '<button type="button" class="hf3sb__slot" data-slot="' + i + '" aria-pressed="' + (i === a) + '"><span class="hf3sb__dot">' + img(p.thumb, '') + '</span><span><small>PAIR ' + (i + 1) + '</small><strong>' + esc(p.name) + '</strong></span></button>';
      thumbHtml += '<div class="hf3sb__thumb' + (i === a ? ' is-active' : '') + '">' + img(p.thumb, p.name) + '</div>';
    }
    root.querySelector('[data-slots]').innerHTML = slotHtml;
    root.querySelector('[data-thumbs]').innerHTML = thumbHtml;
    var cur = find(state.slots[a]);
    var pics = (cur.imgs && cur.imgs.length) ? cur.imgs : [cur.img];
    var hero = root.querySelector('[data-hero]');
    if (hero.getAttribute('data-for') !== cur.handle) {
      hero.setAttribute('data-for', cur.handle);
      hero.innerHTML = '<div class="hf3sb__gallery" data-gallery tabindex="0" aria-label="' + esc(cur.name) + ' photos">' +
        pics.map(function (u, i) { return '<div class="hf3sb__slide">' + img(u, cur.name + ' photo ' + (i + 1) + ' of ' + pics.length) + '</div>'; }).join('') + '</div>' +
        (pics.length > 1 ? '<button type="button" class="hf3sb__arrow hf3sb__arrow--prev" data-gal="-1" aria-label="Previous photo">&lsaquo;</button>' +
          '<button type="button" class="hf3sb__arrow hf3sb__arrow--next" data-gal="1" aria-label="Next photo">&rsaquo;</button>' +
          '<span class="hf3sb__count" data-count>1 / ' + pics.length + '</span>' : '') +
        (cur.url && cur.handle !== startH ? '<a class="hf3sb__details" href="' + cur.url + '">See details</a>' : '');
      var g = hero.querySelector('[data-gallery]'), c = hero.querySelector('[data-count]');
      if (g && c) g.addEventListener('scroll', function () { c.textContent = (Math.round(g.scrollLeft / g.clientWidth) + 1) + ' / ' + pics.length; }, { passive: true });
    }
    root.querySelector('[data-pick-label]').textContent = 'Pair ' + (a + 1) + ' of ' + n + ' · Choose your style';

    root.querySelector('[data-styles]').innerHTML = products.map(function (p) {
      var low = p.available && p.tracked && p.qty > 0 && p.qty <= lowAt;
      return '<button type="button" class="hf3sb__style" data-style="' + p.handle + '" aria-pressed="' + (state.slots[a] === p.handle) + '"' + (p.available ? '' : ' disabled') + '>' +
        '<span class="hf3sb__swatch">' + img(p.thumb, '') + '</span><span class="hf3sb__style-name">' + esc(p.name) + '</span>' +
        (low ? '<span class="hf3sb__low">Low stock</span>' : '') + (p.available ? '' : '<span style="font-size:11px;font-weight:600">Back soon</span>') + '</button>';
    }).join('');

    var t = stackTotal(n);
    var addonOn = !!(addon && state.addon && n === 3);
    var grand = t.total + (addonOn ? addon.price : 0);
    var away = threshold - grand;
    var nudge = root.querySelector('[data-nudge]');
    if (nudge) {
      if (n < 3) {
        var t3 = stackTotal(3);
        var shipFree = t3.total >= threshold && t.total < threshold;
        var label = (n === 2 ? 'Add a 3rd pair for just ' + money(t3.total - t.total) : 'Make it a stack: 3 pairs for ' + money(t3.total)) + (shipFree ? ' + ship free' : '');
        nudge.innerHTML = '<button type="button" class="hf3sb__nudge" data-tier="3">' + label + ' <span aria-hidden="true">&rarr;</span></button>';
      } else if (addon && (threshold - t.total > 0 || state.addon)) {
        nudge.innerHTML = '<button type="button" class="hf3sb__addon" data-addon-toggle aria-pressed="' + addonOn + '">' +
          '<span class="hf3sb__dot">' + img(addon.thumb, '') + '</span><span><strong>' + (addonOn ? 'Added: ' : 'Add ') + esc(addon.name) + ' +' + money(addon.price) + '</strong>' +
          '<small>' + (addonOn ? 'Free shipping unlocked' : 'Unlocks free shipping') + '</small></span></button>';
      } else { nudge.innerHTML = ''; }
    }
    root.querySelector('[data-ship-msg]').textContent = away > 0 ? "You're " + money(away) + ' away from free shipping' : 'You unlocked free shipping';
    root.querySelector('[data-ship-bar]').style.width = Math.min(100, Math.round(grand / threshold * 100)) + '%';
    root.querySelector('[data-add]').textContent = 'Add ' + n + (n === 1 ? ' pair' : ' pairs') + (addonOn ? ' + scrunchie' : '') + ' · ' + money(grand);
  }

  function addItems(items, btn) {
    var err = root.querySelector('[data-error]');
    err.hidden = true;
    var merged = {};
    items.forEach(function (id) { merged[id] = (merged[id] || 0) + 1; });
    var payload = { items: Object.keys(merged).map(function (id) { return { id: parseInt(id, 10), quantity: merged[id] }; }) };
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { window.location.href = root.getAttribute('data-cart') || '/cart'; })
      .catch(function (e) { btn.disabled = false; btn.textContent = label; err.textContent = (e && e.description) || 'Something went wrong adding your stack. Please try again.'; err.hidden = false; });
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-tier')) { state.n = +b.getAttribute('data-tier'); state.active = Math.min(state.active, state.n - 1); render(); }
    else if (b.hasAttribute('data-gal')) { var gl = root.querySelector('[data-gallery]'); if (gl) gl.scrollBy({ left: gl.clientWidth * +b.getAttribute('data-gal'), behavior: 'smooth' }); }
    else if (b.hasAttribute('data-slot')) { state.active = +b.getAttribute('data-slot'); render(); }
    else if (b.hasAttribute('data-style')) { var a = Math.min(state.active, state.n - 1); state.slots[a] = b.getAttribute('data-style'); state.active = (a + 1) % state.n; render(); }
    else if (b.hasAttribute('data-addon-toggle')) { state.addon = !state.addon; render(); }
    else if (b.hasAttribute('data-add')) {
      var ids = state.slots.slice(0, state.n).map(function (h) { return find(h).variant; });
      if (addon && state.addon && state.n === 3) ids.push(addon.variant);
      addItems(ids, b);
    }
    else if (b.hasAttribute('data-stack')) {
      var hs = b.getAttribute('data-stack').split(',').filter(Boolean);
      var allSocks = hs.every(function (h) { return products.some(function (p) { return p.handle === h && p.available; }); });
      if (allSocks && hs.length <= 3) {
        state.n = hs.length; state.active = 0;
        hs.forEach(function (h, i) { state.slots[i] = h; });
        render(); root.querySelector('#build').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        var ids = hs.map(function (h) { var x = extra[h]; return x && x.available ? x.variant : null; }).filter(Boolean);
        if (ids.length) addItems(ids, b);
      }
    }
  });

  render();
}
function hf3InitAll() { document.querySelectorAll('.hf3sb').forEach(hf3InitStack); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hf3InitAll); else hf3InitAll();
document.addEventListener('shopify:section:load', hf3InitAll);
})();